export const counterpartyKeys = {
  all: ['counterparties'] as const,
  lists: () => [...counterpartyKeys.all, 'list'] as const,
  list: (filters: string) => [...counterpartyKeys.lists(), { filters }] as const,
  /**
   * LR-572: server-searched picker pages. Keyed by query so each one caches, and
   * by `activeOnly` so the registry-wide list filter and the active-only billing
   * pickers cannot land in the same entry. Under `lists()`, not beside it: the
   * registry mutations invalidate that prefix, and a picker that misses the
   * invalidation keeps offering a counterparty someone just deactivated.
   */
  search: (query: string, activeOnly: boolean) =>
    [...counterpartyKeys.lists(), 'search', { query, activeOnly }] as const,
  /** Windowed register pages, keyed by their narrowing. Under `lists()` like
   *  `search`, so a registry mutation invalidates the table too. */
  register: (params: Record<string, unknown>) =>
    [...counterpartyKeys.lists(), 'register', params] as const,
  details: () => [...counterpartyKeys.all, 'detail'] as const,
  detail: (id: number | string) => [...counterpartyKeys.details(), id] as const,
  presets: () => [...counterpartyKeys.all, 'presets'] as const,
  preset: (id: number | string) => [...counterpartyKeys.presets(), id] as const,
  history: (id: string) => [...counterpartyKeys.all, 'history', id] as const,
};
